
export class WarehouseModal {
    public constructor(
        id: string,
        count: number,
        expireDate: string,
        drugId: string,
        PackageCount: number,
        companyName: any,
        brandName: string,
        stockPersianName: string,
        SourceStockId: string,
        inventoryDetailId: string,
    ) {
        this.id = id;
        this.count = count;
        this.expireDate = expireDate;
        this.drugId = drugId;
        this.drugPackageCount = PackageCount;
        this.companyName = companyName;
        this.brandName = brandName;
        this.maxTransfer = count;
        this.destinationStockId = "";
        this.maxCount = count;
        this.stockPersianName = stockPersianName;
        this.SourceStockId = SourceStockId;
        this.inventoryDetailId = inventoryDetailId;
    }
    public id: string;
    public count: number;
    public expireDate: string;
    public drugId: string;
    public drugPackageCount: number;
    public PackageCount?: number;
    public companyName: any;
    public brandName: string;
    public maxTransfer: number;
    public destinationStockId: string;
    public maxCount: number;
    public stockPersianName: string;
    public SourceStockId: string;
    public DestinationStockId?: string;
    public inventoryDetailId: string;

}
